<script>
  import { onMount } from 'svelte';
  import Repeats from './Repeats';
  import draft from 'stores/Draft';
  import YarnDropDown from './YarnDropDown';
  import NewIcon from 'icons/new.svg';
  import store from './YarnFillTableStore';

  /*
  $: length = 1;
  $: if (data[0] !== undefined && data[0].length > 0) {
    length = data[0].length;
  }
  */

  let repeats = [];
  let tableElement;

  $: newColumnIndex = -1;
  $: yarn = -1;

  $: if (yarn !== -1) {
    store.table.addYarn(yarn);
    yarn = -1;
  }

  onMount(() => {
    store.initialize($draft.yarn);
  });

  let repeatComponent;

  function deleteRow(row) {
    store.table.deleteRow(row);
  }

  function setValue(column, row, value) {
    store.table.setValue(column, row, value);
  }

  function insertColumn(index) {
    store.insertColumn(index);
    window.setTimeout(() => {
      let tds = tableElement.querySelectorAll('.new');
      if (tds.length > 0) {
        for (let i = 0; i < tds.length; i++) {
          tds[i].style.width = '3em';
        }
        tds[0].addEventListener(
          'transitionend',
          () => {
            for (let i = 0; i < tds.length; i++) {
              tds[i].style.width = '';
              tds[i].classList.remove('new');
            }
          },
          { once: true }
        );
      }
    }, 10);
    window.setTimeout(() => {
      newColumnIndex = -1;
    }, 200);
    newColumnIndex = index;
    repeatComponent.insertColumn(index);
  }

  function onFocus(columnIndex) {
    if (lastBlur !== undefined && columnIndex !== lastBlur) {
      let column = lastBlur;
      let removeColumn = true;
      let data = $store.tableData;
      for (let i = 0; i < data.length; i++) {
        if (
          data[i][column] !== undefined &&
          data[i][column] !== '' &&
          data[i][column] !== 0
        ) {
          removeColumn = false;
          break;
        }
      }
      if (removeColumn) {
        store.table.removeColumn(column);
        repeatComponent.removeColumn(column);
      }
    }
  }

  export function getThreads() {
    let tableThreads = store.table.toThreads();
    let threads = [...tableThreads];
    for (let i = 0; i < repeats.length; i++) {
      let repeatRow = repeats[i];
      for (let j = repeatRow.length - 1; j >= 0; j--) {
        let rep = repeatRow[j];
        let part = threads.slice(rep.from, rep.to + 1);
        for (let k = 0; k < rep.times - 1; k++) {
          threads.splice(rep.from, 0, ...part);
        }
        let change = (rep.to - rep.from + 1) * (rep.times - 1);
        // Adjust lower repeats after changed thread list length
        for (let k = i + 1; k < repeats.length; k++) {
          let lowerRow = repeats[k];
          for (let l = 0; l < lowerRow.length; l++) {
            let rep1 = lowerRow[l];
            if (rep1.to >= rep.to) {
              rep1.to += change;
            }
          }
        }
      }
    }
    let ret = [];
    threads.forEach((th) => {
      for (let i = 0; i < th.times; i++) {
        ret.push(th.yarn);
      }
    });
    ret.reverse();
    return ret;
  }

  let lastBlur;
  function onBlur(columnIndex) {
    lastBlur = columnIndex;
  }
</script>

<div class="top">
  <table bind:this={tableElement}>
    <tbody>
      {#each $store.tableData as _, row}
        <tr>
          <td>
            {#if row === 0}
              <button class="add-button" on:click={() => insertColumn(0)}>
                {@html NewIcon}
              </button>
            {/if}
            <YarnDropDown
              selectedYarn={$store.yarns[row]}
              on:input={(e) => {
                if (e.target.value === '-1') {
                  deleteRow(row);
                } else {
                  $store.tableData[row][0] = e.target.value;
                }
              }}
            />
          </td>
          {#each { length: $store.width } as _, column}
            <td class:new={column === newColumnIndex} data-column={column}>
              {#if row === 0}
                <button
                  class="add-button"
                  on:click={() => insertColumn(column + 1)}
                >
                  {@html NewIcon}
                </button>
              {/if}
              <input
                size="4"
                type="number"
                on:focus={() => onFocus(column)}
                on:blur={() => onBlur(column)}
                value={$store.tableData[row][column] !== undefined
                  ? $store.tableData[row][column]
                  : ''}
                on:input={(e) => setValue(column, row, Number(e.target.value))}
              />
            </td>
          {/each}
        </tr>
      {/each}
      <tr>
        <td>
          <YarnDropDown bind:selectedYarn={yarn} />
        </td>
      </tr>

      <Repeats bind:this={repeatComponent} bind:repeats />
    </tbody>
  </table>
</div>

<style>
  table {
    border-collapse: collapse;
    border: 3px solid black;
    background-color: white;
    position: relative;
  }

  .top {
    padding-top: 20px;
  }

  td {
    border: 3px solid black;
    min-width: 1.5rem;
    text-align: center;
    position: relative;
    transition-property: width;
    transition-duration: 200ms;
  }

  tr {
    height: 1rem;
  }

  input {
    margin: 0;
    padding: 0;
    width: 3em;
    background: none;
    border-radius: 0;
  }

  td.new * {
    width: 0px;
  }
  td.new {
    min-width: 0px;
    width: 0;
  }

  .add-button {
    position: absolute;
    right: 0;

    width: 30px;
    height: 30px;
    margin: 0;
    padding: 0;
    float: right;
    transform: translate(calc(50% + 2px), calc(-100% - 2px));
    background-color: transparent;
  }

  .add-button:hover {
    border: 0;
  }

  .add-button:active {
    background: none;
  }

  .add-button:active :global(svg) {
    fill: black;
  }
  .add-button:active :global(svg .plus) {
    fill: white;
    stroke: white;
  }

  .add-button :global(svg) {
    fill: white;
  }
</style>
